<template>
    <div>
        <h3>Grundeinstellungen</h3>
        <div class="form-group">
            <label>URL</label>
            <input class="form-control" type="text" name="url" placeholder="https://..." v-model="settings.url"
                   @input="inputChanged">
            <span class="form-text text-muted">Unterstützte Dateitypen: csv, tsv, txt, json</span>
        </div>

        <div v-if="requiresAdditionalInfo" class="mt-3">
            <div class="row">
                <div class="col-xl-4">
                    <div class="form-group">
                        <label>Trennzeichen</label>
                        <input class="form-control" type="text" name="delimiter" placeholder="; oder \t für Tabulatoren"
                               required
                               v-model="settings.delimiter"
                               @input="inputChanged"/>
                        <span class="form-text text-muted">Geben Sie das Trennzeichen an, mit dem die Spalten in Ihrer Datei getrennt werden. Üblicherweise Semikolon oder Komma.</span>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="form-group">
                        <label>Textumschließung</label>
                        <input class="form-control" type="text" name="enclosure" placeholder="Keine Textumschließung"
                               v-model="settings.enclosure"
                               @input="inputChanged"/>
                        <span class="form-text text-muted">Dieses Feld nur ausfüllen, falls Zeichenketten mit einem bestimmten Zeichen begrenzt sind.</span>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="form-group">
                        <label>Zeile mit Überschriften</label>
                        <input class="form-control" type="number" name="header_offset" value="0" min="0"
                               v-model="settings.header_offset"
                               @input="inputChanged"
                               placeholder="Die erste Zeile hat den Index 0"/>
                        <span class="form-text text-muted">Lassen Sie diesen Wert unverändert, falls die Überschriften in der ersten Zeile stehen.</span>
                    </div>
                </div>
            </div>
        </div>

        <spinner v-if="loading" class="mt-3"/>

        <errors v-if="errorMessage"
                :errors="{'0': errorMessage}"
        />
    </div>
</template>

<script>
import Errors from '@components/Errors'
import Spinner from 'vue-simple-spinner'

export default {
    components: {
        Errors,
        Spinner,
    },

    data() {
        return {
            loading: false,
            requiresAdditionalInfo: false,
            errorMessage: '',
            supportedContentTypes: [
                'application/json',
                'text/plain',
                'text/csv',
                'text/tab-separated-values',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
            ],
            excelContentTypes: [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
            ],
            settings: {
                url: '',
                delimiter: '',
                enclosure: '',
                header_offset: 0,
            },
        }
    },

    methods: {
        inputChanged(e) {
            this.loading = true
            this.requiresAdditionalInfo = false
            let url = e.target.value

            fetch(url, {method: 'HEAD'}).then(response => {
                let contentType = response.headers.get('content-type')

                if (response.ok && this.supportedContentTypes.includes(contentType)) {
                    this.errorMessage = ''
                    this.requiresAdditionalInfo = !this.excelContentTypes.includes(contentType) && contentType !==
                        'application/json'
                    this.$emit('canProceed', true)
                } else {
                    if (!response.ok) {
                        this.errorMessage = `Fehler beim Laden der Resource (${response.status}). Bitte prüfen Sie Ihre Datenquelle.`
                    } else {
                        this.errorMessage = `Ungültiges Dateiformat ${contentType}. Unterstützt: ${this.supportedContentTypes.join(
                            ', ')}`
                    }
                    this.$emit('canProceed', false)
                }

                this.loading = false
            })
        },
    },

    watch: {
        settings: {
            handler() {
                this.$emit('input', this.settings)
            },
            deep: true,
        },
    },
}
</script>
